var _rect, _circle, _circle2, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 220,
    viewBox: "0 0 320 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 220,
    rx: 20,
    fill: "#E3F2FD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 90,
    r: 28,
    fill: "#1976D2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 90,
    r: 28,
    fill: "#64B5F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 130,
    width: 160,
    height: 40,
    rx: 20,
    fill: "#90CAF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.c049262a57a22c11a4e0c878c2172ad0.svg";
export { ForwardRef as ReactComponent };